import BugReportIcon from '@mui/icons-material/BugReport';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

import type { MenuGroup } from './types';

const FEATURE_REQUEST_URL = 'https://welltech.atlassian.net/jira/software/c/projects/RB/form/2424';
const BUG_REPORT_URL = 'https://welltechcom.slack.com/archives/C067QK3ND32';

const support: MenuGroup = {
    id: 'group-support',
    title: 'Support',
    type: 'group',
    children: [
        {
            id: 'bug-report',
            title: 'Bug report',
            type: 'item',
            url: BUG_REPORT_URL,
            icon: BugReportIcon,
            breadcrumbs: false,
            target: '_blank',
            permission_name: 'selects',
        },
        {
            id: 'feature-request',
            title: 'Feature request',
            type: 'item',
            url: FEATURE_REQUEST_URL,
            icon: ContactSupportIcon,
            breadcrumbs: false,
            target: '_blank',
            permission_name: 'selects',
        },
    ],
};

export default support;
